export default __webpack_public_path__ + "static/partnerIcon11-63817b94d4005858579eb8db4bd00464.svg";